import { TypedDocumentNode, gql } from "@apollo/client";

export enum GetServiceType {
  COURSE_SERVICE = "COURSE_SERVICE",
  CONSULTING_SERVICE = "CONSULTING_SERVICE",
  WEBINAR_SERVICE = "WEBINAR_SERVICE",
  PATTERN_SERVICE = "PATTERN_SERVICE",
  ARTICLE_SERVICE = "ARTICLE_SERVICE",
}

type ServiceList = {
  id: string;
  shortName: string;
};

export const GET_SERVICE_LIST_BY_TYPE: TypedDocumentNode<{
  servicesByType: ServiceList[];
}> = gql`
  query GetServicesByType($serviceType: GetServiceType) {
    servicesByType(serviceType: $serviceType) {
      id
      shortName
    }
  }
`;
